// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1Osqr","description":"MealItem_description__1z9Y8","price":"MealItem_price__xtRd2"};